export enum RelewiseMethods {
    LastSeen = 'search-ms/recommendation/lastviewed',
    MostPopular = 'search-ms/recommendation/popular',
    OthersHaveDoneWith = 'search-ms/recommendation/othershavedonewith/',
    MostPopularByCategory = 'search-ms/recommendation/category/',
    MostPopularByBrand = 'search-ms/recommendation/brand/',
    ByProductId = 'search-ms/Product/SearchProducts',
    Campaign = 'search-ms/Campaign/'
}

export enum RelewiseTypes {
    LastSeen = 'lastSeen',
    MostPopular = 'mostPopular',
    OthersHaveDoneWith = 'othersHaveDoneWith',
    MostPopularByCategory = 'mostPopularByCategory',
    MostPopularByBrand = 'mostPopularByBrand',
    ByProductId = 'byProductId',
    Campaign = 'campaign',
    OtherAlsoBoughtProducts = 'otherAlsoBoughtProducts',
    OtherAlsoSeenProducts = 'otherAlsoSeenProducts'
}
